export const GAME_EVENT_ENVELOPE_TYPE = 'GAME_EVENT' as const;

export interface ParsedGameEvent {
  type: string;
  data: unknown;
}

/** Returns null (not throws) so the hook layer can log + skip without try/catch. */
export function validateGameEventEnvelope(raw: unknown): ParsedGameEvent | null {
  if (!raw || typeof raw !== 'object') return null;
  const envelope = raw as { type?: unknown; payload?: unknown };
  if (envelope.type !== GAME_EVENT_ENVELOPE_TYPE) return null;
  const payload = envelope.payload;
  if (!payload || typeof payload !== 'object') return null;
  const { type, data } = payload as { type?: unknown; data?: unknown };
  if (typeof type !== 'string' || type.length === 0) return null;
  return { type, data };
}
